<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="middle-height-auto"
      class="quoted-price-modal"
      :loading="modalLoading"
      v-on="$listeners"
  >
    <template #header>报价
      <span>{{name}}</span>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="105px"
      >
        <gj-area-title>基本信息</gj-area-title>
        <div>
          <div class="col">
            <el-form-item
                prop="skus"
                label="产品名称/SKU"
                :rules="[
                  $gjRequired('请选择SKU', ['blur', 'change'], !isMeaningful(sku))
                ]"
            >
              <template v-if="isMeaningful(sku)">
                {{skuName}}-{{sku}}
              </template>
              <template v-else>
<!--                <gj-select-->
<!--                    v-model="form.skus"-->
<!--                    type="multi-check"-->
<!--                    :options="skuOptions"-->
<!--                    width="180px"-->
<!--                ></gj-select>-->
                <gj-virtual-select-more
                    :filterable="false"
                    v-model="form.skus"
                  :list="skuOptions"
                  style="width: 180px"
                >
                </gj-virtual-select-more>


              </template>
            </el-form-item>
            <el-form-item
                prop="purchaseDeliveryDays"
                label="采购交期"
                label-width="100px"
                :rules="[
                  $gjRequired('请输入采购交期'),
                  $gjReRule(RE.pt, '请输入正整数')
                ]"
            >
              <gj-input
                  placeholder=""
                  width="180px"
                  v-model="form.purchaseDeliveryDays">
                <template #append>天</template>
              </gj-input>
            </el-form-item>
            <el-form-item
                  prop="moq"
                  label="最小起订量"
                  :rules="[
                    $gjReRule(RE.pt0, '请输入正整数')
                  ]"
              >
                <gj-input
                    width="100%"
                    placeholder="不填则为0"
                    v-model="form.moq"
                ></gj-input>
              </el-form-item>
          </div>
        </div>
        <div>
          <el-form-item label="采购网址">
            <gj-input
                width="100%"
                placeholder="请输入采购网址"
                v-model="form.purchaseUrl"
            ></gj-input>
          </el-form-item>
        </div>
        <gj-area-title>报价信息</gj-area-title>
        <div>
          <div class="col">
            <el-form-item
                prop="currency"
                label="币种"
                :rules="[
                  $gjRequired('请输入选择币种'),
                ]"
            >
              <gj-select
                  :options="[
                    {id: 'CNY', text: 'CNY'},
                    {id: 'USD', text: 'USD'}
                  ]"
                  width="180px"
                  v-model="form.currency"
              ></gj-select>
            </el-form-item>

            <el-form-item
                prop="actualTaxRate"
                label="实际税率"
                :rules="[
                  $gjRequired('请输入实际税率'),
                  $gjReRule(RE.num(2), '请输入最多两位小数的正数'),
                ]"
            >
              <gj-input
                  width="180px"
                  placeholder=""
                  v-model="form.actualTaxRate"
              >
                <template #append>%</template>
              </gj-input>
            </el-form-item>
            <el-form-item
                prop="includeTaxPrice"
                label="含税单价"
                :rules="[
                  $gjRequired('请输入含税单价'),
                  $gjReRule(RE.num(2), '请输入最多两位小数的正数'),
                ]"
            >
              <gj-input
                  v-model="form.includeTaxPrice"
                  width="116px"
                  placeholder="保留两位小数"></gj-input>
              <span style="margin-right: 4px"></span>(不含税单价：{{getExcludeTaxPrice()}})
            </el-form-item>
          </div>
          <div>
            <el-form-item
                prop="invoiceTaxRate"
                label="票面税率"
                label-width="105px"
                :rules="[
                  $gjReRule(RE.num(2), '请输入最多两位小数的正数'),
                ]"
            >
              <gj-input
                  v-model="form.invoiceTaxRate"
                  placeholder=""
                  width="180px">
                <template #append>%</template>
              </gj-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="confirm" type="primary" :loading="loading">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaningfulMixin, modalMixIn, userGuideMixin} from "../../../../../minxins";
  import {isMeaningful, toFixed} from "../../../../../utils/common";
  import {getSkuAndSkuNameSelect} from "../../../../../api/product";
  import {supplierQuoted} from "../../../../../api/purchase";

  export default {
    name: "supplier-add-quoted-price",
    mixins: [modalMixIn, formRuleMixin, isMeaningfulMixin, userGuideMixin],
    props: {
      code: null,
      name: null,
      sku: null,
      skuName: null,
    },
    created() {
      this.form.supplierCode = this.code;
      if (!isMeaningful(this.sku)) {
        this.modalLoading = true;
        getSkuAndSkuNameSelect()
          .then((data) => {
            this.skuOptions = data;
          }).complete(() => this.modalLoading = false)
      } else {
        this.form.skus = [this.sku];
      }
    },
    data() {
      return {
        modalLoading: false,
        loading: false,
        form: {
          supplierCode: null,
          skus: [],
          purchaseDeliveryDays: null,
          moq: null,
          purchaseUrl: null,
          currency: null,
          actualTaxRate: null,
          includeTaxPrice: null,
          invoiceTaxRate: null,
          excludeTaxPrice: null,
        },
        skuOptions: [],
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.form.excludeTaxPrice = this.getExcludeTaxPrice();
          this.loading = true;
          supplierQuoted(this.form)
            .then(() => {
              this.$gjMessage.success('操作成功');
              this.$emit('quotedSuccess');
              this.$emit('userGuide');
              this.$gjDestroy();
            }).complete(() => this.loading = false)
        }
      },
      getExcludeTaxPrice() {
        if (isMeaningful(this.form.actualTaxRate) && isMeaningful(this.form.includeTaxPrice)
          && !isNaN(this.form.actualTaxRate) && !isNaN(this.form.includeTaxPrice)) {
          // return toFixed(Number(this.form.includeTaxPrice) - (Number(this.form.includeTaxPrice) * (Number(this.form.actualTaxRate) / 100)));
          // 不含税单价=含税单价/（1+实际税率）
          return toFixed(Number(this.form.includeTaxPrice) / (1 + (Number(this.form.actualTaxRate) / 100)));
        }
        return 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .quoted-price-modal {
  }

  .quoted-price-modal /deep/ .gj-modal--middle-height-auto .el-dialog {
    height: 450px !important;
    width: 1000px !important;
  }
  .col{
    display: flex;
    justify-content: space-between;
    /deep/ .el-form-item{
      width: 33%;
    }
  }
</style>
